export enum EnvironmentType {
  DEVELOPMENT = 'DEVELOPMENT',
  BUILD = 'BUILD',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION'
}
